import styled, { css } from 'styled-components';

export const Container = styled.div`
  ${({ theme }) => css`
    display: flex;
    flex-direction: column;
    border-radius: 2rem 2rem 0 0;

    width: 100vw;
    max-width: 565px;
    background-color: ${theme.palette.neutral[50]};
    box-shadow: ${theme.layout.shadows.popup};

    overflow-y: auto;
    max-height: 100vh;

    > section {
      display: flex;
      align-items: center;
      flex-direction: column;
      gap: 1rem;
      font-size: ${theme.typography.sizes.body2};
      padding: ${theme.layout.spacing(0, 3, 3)};

      > section {
        display: flex;
        flex-direction: column;
        width: 100%;
        align-items: center;
        text-align: center;
        gap: 1rem;

        a {
          display: flex;
          align-items: center;
          background: ${theme.palette.neutral[50]};
          border: 1px solid ${theme.palette.neutral[300]};
          border-radius: 16px;
          height: 52px;
          gap: 1rem;
          padding: 0 20px;

          width: 100%;
          justify-content: center;

          font-size: ${theme.typography.sizes.body2};
          font-weight: ${theme.typography.weight.regular};
          color: ${theme.palette.text.main};

          svg {
            font-size: 20px;
          }

          transition: all 0.2s;

          &:hover {
            background: ${theme.palette.neutral[100]};
          }
        }
      }

      .skeleton {
        width: 100%;
      }

      img {
        width: 100%;
        border: 2px solid #c289e0;
        border-radius: 18px;
      }

      footer {
        display: flex;
        flex-direction: column;
        width: 100%;
        gap: 1rem;

        button {
          width: 100%;
        }
      }
    }

    @media (min-width: ${theme.layout.breakpoints.md}) {
      border-radius: 2rem;
    }
  `}
`;
